import { batch } from "solid-js";
import { reconcile } from "solid-js/store";

import { Get } from "@repo/utils/api";
import FeatureStore from "@repo/utils-solid/FeatureStore";
import Product from "@repo/vygor-models/Product";

import { api } from "..";

export { Product };

export type ProductsRest = {
  [id: Product.Id]: Get<
    {},
    {
      product: Product;
    }
  >;
};

const initialState = {
  byId: {} as Record<Product.Id, Product>,
};

export const { Context, Provider, useProducts } = FeatureStore.init(
  "Products",
  initialState,
  ([store, setStore], { withLogger, attachAction }) => {
    const accessors = {
      byId: attachAction(
        (id: Product.Id) => store.byId[id],
        (id) => actions.fetch(id),
      ),
    };

    const mutations = {
      one(product: Product) {
        setStore("byId", product.id, reconcile(product));
      },
      many(products: Product[]) {
        batch(() => {
          for (const product of products) {
            mutations.one(product);
          }
        });
      },
    };

    const actions = withLogger("action", {
      one: mutations.one,
      many: mutations.many,
      fetch(id: Product.Id) {
        return api.products[id]!.GET({}).then(({ product }) => {
          mutations.one(product);
        });
      },
    });

    return { accessors, actions };
  },
);
